<template>
    <div>
        <el-upload
            :limit="1"
            :on-exceed='beyondNum'
            accept="video/mp4,video/*"
            size="mini"
            multiple
            action=""
            ref="upload"
            :before-upload="beforeAvatarUpload"
            :on-remove="handleRemove"
            :http-request="uploadHttp"
            :file-list="fileList">
            <el-button size="mini" type="primary" :loading="upBao" :style="styleEd">{{!upBao? url? '已完成':text:$store.getters.is_videoRess+'%'}}<i v-show="!url" class="el-icon-upload el-icon--right"></i></el-button>
        </el-upload>
    </div>
</template>
 
<script>
import utils from '../lib/util'
import os from '../lib/oss'
export default {
    props:{
        editRrl:String,
        limitSize:String,//大小限制 不传则不限制
        text:{
            type:String,
            default:'上传视频',
        },
        styleEd:{
            type:String,
            default:'',
        }
    },
    data () {
        return {
            fileList:[],
            url:'',
            upBao:false,
            videoSize:'0KB'
        }
    },
    components:{
    },
    computed:{
        ressPuted_video:function(){
            let size = this.videoSize
            let saveGl = size.substring(size.length - 2)
            let maxSize = this.$store.getters.is_videoRess
            return String(utils.unsingNumber(size.replace(/(KB|MB|GB|TB)/g,'')*(String(maxSize).replace(/(%)/g,'')/100),'floor',2))+saveGl
        }
    },
    watch:{
        editRrl:{
            handler(now,old){
                this.editMet()
            }
        },
        deep:true
    },
    mounted: function () {
        this.editMet()
    },
    methods: {
        //编辑
        editMet(){
            this.fileList = []
            if(/(https:|https:)/g.test(this.editRrl)) {
                this.url =  utils.getVideoUrl(this.editRrl)[0]
                let a = utils.getVideoUrl(this.editRrl)
                if(a.length > 0) {
                    a.forEach(item => {
                        var obj = {}
                        let index = item.lastIndexOf('\/');
                        let fileName  = item.substring(index + 1, item.length);
                        this.$set(obj,'name',fileName);
                        this.$set(obj,'url',this.url);
                        this.fileList.push(obj);
                    })
                }
            }
        },
        //超出最大上传数量
        beyondNum(){
            this.$message.success('最大上传一个视频文件')
        },
        beforeAvatarUpload (file) {
            let isSize = this.limitSizeFoo(file.size,this.limitSize)
            if (!isSize) {
                this.$message.error(`上传视频大小不能超过 ${this.limitSize/1024}MB!`);
            }
            return isSize;
            // return file;
        },
        limitSizeFoo(isSize,limitSize=null){//KB
            if(limitSize==null) return true
            isSize = isSize / 1000;
            if(Number(isSize)<=Number(limitSize)){
                return true
            }else{
                return false
            }
        },
        close(){
            this.url = ''
            this.$refs.upload.clearFiles();
            this.upBao = false
            os.cancelFun('video');
        },
        //删除图片
        handleRemove(file, fileList) {
            this.fileList = utils.empty(this.fileList)
            this.url = ''
            this.upBao = false
            os.cancelFun('video');
        },
        //阿里云OSS上传
        uploadHttp({ file }) {
            let that = this
            that.upBao = true
            that.videoSize = String(utils.getFileSize(file.size))
            os.uploadHttp(file,function(e,file){
                that.upBao = false
                that.url = e
                that.$emit('upImgUrl',e)
            })
        }
    }
}
</script>
<style scope>
    #up-video{
        max-height: 230px;
        max-width: 100%;
        border: 1px dotted #000;
    }
</style>



// WEBPACK FOOTER //
// src/components/updataVideo.vue